export var VisualState;
(function (VisualState) {
    VisualState["INCOMPLETE"] = "incomplete";
    VisualState["COMPLETE"] = "complete";
})(VisualState || (VisualState = {}));
export var SECTION_WIDGET_VIEWTYPES;
(function (SECTION_WIDGET_VIEWTYPES) {
    SECTION_WIDGET_VIEWTYPES["EXPANDED"] = "expanded";
    SECTION_WIDGET_VIEWTYPES["COLLAPSED"] = "collapsed";
})(SECTION_WIDGET_VIEWTYPES || (SECTION_WIDGET_VIEWTYPES = {}));
